import {CCol, CRow } from '@coreui/react';
import React from 'react';

const AccountActivation = () => {
  return (
    <CRow>
      <CCol className="flex-column flex-center">
        <h1 className="text-center">Account Activation</h1>
        <p className="text-center">Welcome! Thank you for registering your new Glympse PRO account. There are just a few more steps for you to complete the account setup process.</p>
        <p className="text-center">We have sent you an account activation link via email. Please check your email now.</p>
        <p className="text-center">After clicking on the activation link you receive, the next step will be to setup your payment details.</p>
        <p className="text-center">Didn’t receive your activation email? Be sure to check your junk folder. Use the button below to resend your activation link. The activation link is time-sensitive and only live for 4 hours. Please be sure to click it within that timeframe to continue your registration.</p>
      </CCol>
    </CRow>
  );
};

export default AccountActivation;
